import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGift } from '@soundxyz/font-awesome/pro-regular-svg-icons/index.mjs';
import type { GiftSource } from '@soundxyz/utils/analytics';
import { GiftingModal } from '@components/modals/GiftingModal';
import { ModalContext, ModalType } from '@context/modal';
import { GiftingModalFragmentDoc } from '@graphql/reactQuery';
import { type FragmentType, getFragment } from '@graphql/reactQuery';
import { trackClickEvent } from '@lib/analytics';
import { DropdownMenuItem, MenuItemLabel } from '../GlobalDropdown';

export const GiftMenuItem = ({
  releaseFrag,
  sourceComponent,
}: {
  releaseFrag: FragmentType<GiftingModalFragmentDoc>;
  sourceComponent: GiftSource;
}) => {
  const { openModal } = ModalContext.useContainer();
  const release = getFragment(GiftingModalFragmentDoc, releaseFrag);

  return (
    <DropdownMenuItem
      onClick={() => {
        trackClickEvent({
          event: 'Gift Clicked',
          properties: {
            associationId: release.id,
            associationType: 'Release',
            sourceComponent,
          },
        });
        openModal(ModalType.GIFT_MODAL, {
          body: <GiftingModal releaseFrag={releaseFrag} />,
        });
      }}
    >
      <FontAwesomeIcon icon={faGift} size="lg" />
      <MenuItemLabel>Gift</MenuItemLabel>
    </DropdownMenuItem>
  );
};
